export default __webpack_public_path__ + "static/media/bankaltimtara.ce458341.png";